import SmartPillLogData from '../store/schema/SmartPillLogData';

export default function resetSmartPillLogData(logData: SmartPillLogData) {
    // This function is to reset the dynamic data which capture users' click actions with smart pills.
    // Other fields in SmartPillLogData are static data which remain the same and have no need for resetting.
    // Each time the smart pills re-render, we call this function to clear up the previous action loggings
    // to make sure we do not log previous clicks in the next rendering.

    logData.mainPayload.timeClicked = null;
    delete logData.mainPayload.subtype;
}
